// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__gql8J","buttons":"SendReceipts_buttons__3tzXK","email":"SendReceipts_email__E8Nma","bookApptTitle":"SendReceipts_bookApptTitle__1Mqeg"};